import React from "react";

// Toggle chips for picking any number of options. `labels` and `hints` are optional display text per option.
function ChipGroup({ name, options, value = [], onChange, labels = {}, hints = {} }) {
  const selected = value || [];
  return (
    <div className="chip-group" role="group" aria-label={name}>
      {options.map((option) => {
        const active = selected.includes(option);
        return (
          <button
            key={option}
            type="button"
            className={`chip ${active ? "active" : ""}`}
            aria-pressed={active}
            onClick={() => onChange(active ? selected.filter((v) => v !== option) : [...selected, option])}
          >
            {active && <i className="bi bi-check2" />}
            {labels[option] || option}
            {hints[option] && <span className="chip-count">{hints[option]}</span>}
          </button>
        );
      })}
    </div>
  );
}

export default ChipGroup;
